export const create = {
  form: {
    name: 'Name',
    totalTimeUsed: 'Total Time Used',
    totalLife: 'Total Life',
    submit: 'Submit',
    timeUnit: 'Mins',
    addMoreMachineComponent: 'Add More Machine Component',
    requireServiceLife: 'Please input machine component service life',
    requireName: 'Please input machine component name',
  },
  pageHeader: {
    title: 'New Machine Component',
    back: 'Back',
  },
}
